<template>
    <section class="founder-thoughts">

        <div class="founder-thoughts__container">

            <!--==========================================
						BLOCK 1
			===========================================-->

            <article class="founder-thoughts__block">

                <div class="founder-thoughts__content">

                    <span class="founder-thoughts__tag uppercase">

                        {{ 'founder_thoughts' | staticTitle }}

                    </span>

                    <div class="founder-thoughts__divider"></div>

                    <vue-marked>{{ 'founder_thoughts' | staticContent }}</vue-marked>

                    <!-- <h2>

                        The Purpose of Enterprise

                    </h2>

                    <p>
                        Every enterprise within the Bridgerocks Group exists because people matter. Business is simply
                        the means through which that conviction is expressed, multiplied, and sustained across
                        generations.
                    </p>

                    <p>
                        Business is not merely an exchange of goods, services, or capital. At its highest expression,
                        enterprise is the disciplined creation of value that enables people to achieve their goals,
                        realize their potential, and improve their lives.
                    </p>

                    <p>
                        When value is created faithfully, ethical prosperity follows. Recognition, enduring
                        relationships, continued opportunities, and financial success are not competing objectives—they
                        are the natural rewards of serving others with excellence and integrity.
                    </p> -->

                </div>

                <div class="founder-thoughts-signature-holder">

                    <img class="founder-thoughts-signature" :src="'seo-signature.png'|assetsImg"  alt="SEO Signature">

                </div>

            </article>

        </div>

    </section>
</template>

<script>
export default {
    name: 'FounderThoughts',
    methods: {
        UI_UX() {
            try {

                const sectionHolder = document.querySelector(".founder-thoughts");

                if (sectionHolder) {

                    const sectionBlocks = sectionHolder.querySelectorAll(".founder-thoughts__block");

                    const sectionObserver = new IntersectionObserver((entries) => {

                        entries.forEach(entry => {

                            if (!entry.isIntersecting) return;

                            sectionBlocks.forEach((block, blockIndex) => {

                                block.animate(

                                    [

                                        {

                                            opacity: 0,
                                            transform: "translateY(50px)"

                                        },

                                        {

                                            opacity: 1,
                                            transform: "translateY(0)"

                                        }

                                    ],

                                    {

                                        duration: 800,
                                        delay: blockIndex * 250,
                                        easing: "cubic-bezier(.19,1,.22,1)",
                                        fill: "forwards"

                                    }

                                );

                                const elements = block.querySelectorAll(".founder-thoughts__content > *");

                                elements.forEach((element, index) => {

                                    element.animate(

                                        [

                                            {

                                                opacity: 0,
                                                transform: "translateY(25px)"

                                            },

                                            {

                                                opacity: 1,
                                                transform: "translateY(0)"

                                            }

                                        ],

                                        {

                                            duration: 700,
                                            delay: (blockIndex * 250) + 150 + (index * 120),
                                            easing: "cubic-bezier(.19,1,.22,1)",
                                            fill: "forwards"

                                        }

                                    );

                                });
                            });

                            sectionObserver.unobserve(entry.target);

                        });

                    }, {

                        threshold: .10

                    });

                    sectionObserver.observe(sectionHolder);

                }
            } catch (e) {
                console.error('Error in FounderThoughts UI_UX:', e);
            }
        }
    },
    mounted() {
        setTimeout(this.UI_UX, 100);
    }
};
</script>

<style lang="scss">

.founder-thoughts {

    position: relative;

    background: #ECE8E0;

    padding: 100px 20px;

    overflow: hidden;
  
    background: #0F1824;

}

.founder-thoughts__container {

    width: 100%;

    max-width: 1280px;

    margin: auto;

}

.founder-thoughts__block {

    display: grid;

    grid-template-columns: 1fr 270px;

    column-gap: 45px;

    align-items: center;

    padding: 55px 0;

    border-top: 1px solid rgba(20, 28, 40, .12);

}

.founder-thoughts__block:first-child {

    padding-top: 0;

    border-top: none;

}

.founder-thoughts__block:last-child {

    padding-bottom: 0;

}

.founder-thoughts__content {

    width: 100%;

}

.founder-thoughts__tag {

    display: block;

    margin-bottom: 12px;

    font-size: 12px;

    font-weight: 600;

    letter-spacing: 2px;

    text-transform: uppercase;

    color: #6E7278;

    color: var(--primary);

}

.founder-thoughts__divider {

    width: 70px;

    height: 2px;

    background: var(--primary);

    margin-bottom: 22px;

}

.founder-thoughts__content h2 {

    font-family: "Cormorant Garamond", serif;

    font-size: 56px;

    line-height: 60px;

    font-weight: 500;

    color: #1B2230;

    margin-bottom: 20px;

    color: #FFF;

}

.founder-thoughts__content p {

    max-width: 920px;

    font-size: 17px;

    line-height: 30px;

    font-weight: 300;

    color: #32363C;

    margin-bottom: 14px;

    color: #b9b9b9;

}

.founder-thoughts__content p:last-child {

    margin-bottom: 0;

}

.founder-thoughts__content strong {

    color: #1B2230;

    font-weight: 600;

}

.founder-thoughts__block {

    transition: transform .4s ease;

}

.founder-thoughts__block:hover {

    transform: translateY(-5px);

}


.founder-thoughts__divider {

    transition: width .4s ease;

}

.founder-thoughts__block:hover .founder-thoughts__divider {

    width: 110px;

}

.founder-thoughts__block {

    opacity: 0;

    transform: translateY(50px);

}

.founder-thoughts__content>* {

    opacity: 0;

    transform: translateY(25px);

}

.founder-thoughts-signature {

    width: 200px;

}

.founder-thoughts-signature-holder img {

    height: auto;

    display: block;

}

@media (max-width:768px) {

    .founder-thoughts {

        padding: 60px 20px;

    }

    .founder-thoughts__block {

        grid-template-columns: 1fr;

        gap: 25px;

        padding: 45px 0;

    }

    .founder-thoughts-signature-holder {

        display: flex;

        justify-content: center;

    }

    .founder-thoughts-signature {

        width: 160px;

    }

    .founder-thoughts__tag {

        font-size: 11px;

    }

    .founder-thoughts__divider {

        width: 55px;

        margin-bottom: 18px;

    }

    .founder-thoughts__content h2 {

        font-size: 40px;

        line-height: 46px;

    }

    .founder-thoughts__content p {

        font-size: 16px;

        line-height: 28px;

    }

}
</style>